<script module>
	//let initialized = false;

	export const baseUrl =
		document.body.getAttribute("baseUrl") ||
		document.body.getAttribute("baseurl");

	export function download(url) {
		window.open(url, "_blank", "noopener,noreferrer");
	}

	export function pluralize(word, count) {
		if (count === 1) {
			if (word.endsWith("ies")) return word.slice(0, -3) + "y";
			if (word.endsWith("es") && /(x|ch|sh|s)$/.test(word.slice(0, -2)))
				return word.slice(0, -2);
			if (word.endsWith("s") && !word.endsWith("ss"))
				return word.slice(0, -1);
			return word;
		}

		if (word.match(/(x|ch|sh|s)$/) && !word.endsWith("ss"))
			return word + "es";
		if (word.endsWith("y") && !/[aeiou]y$/.test(word))
			return word.slice(0, -1) + "ies";

		return word.endsWith("s") ? word : word + "s";
	}

	export function loadAssets(rootName, parent) {
		let root;
		if (parent) root = parent.querySelector(rootName)?.shadowRoot;
		else root = document.querySelector(rootName)?.shadowRoot;
		const link = document.createElement("link");
		link.rel = "stylesheet";
		link.href = `${baseUrl}css/sbundle.css`;
		if (!root) return null;
		root.appendChild(link);
		return root;
	}

	export function calculateAge(birthDate, asOfDate) {
		if (isNaN(birthDate)) return null;
		if (!asOfDate || isNaN(asOfDate)) asOfDate = new Date();
		const age = asOfDate.getFullYear() - birthDate.getFullYear();
		const monthDiff = asOfDate.getMonth() - birthDate.getMonth();
		const dayDiff = asOfDate.getDate() - birthDate.getDate();
		const adjustedAge = monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? age - 1 : age;
		return adjustedAge;
	}

	export function formatBytes(bytes) {
		if (bytes === 0) return "0 Bytes";

		const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
		const i = Math.floor(Math.log(bytes) / Math.log(1024));

		const value = bytes / Math.pow(1024, i);
		let formattedValue = value.toFixed(2).replace(/\.?0+$/, "");

		const unit = i === 0 && formattedValue === "1" ? "Byte" : sizes[i];

		return `${formattedValue} ${unit}`;
	}

	export function formatPhone(value) {
		if (!value) return "";
		const cleaned = value.replace(/\D/g, "");
		if (cleaned.length !== 10) return cleaned;
		const areaCode = cleaned.slice(0, 3);
		const centralOffice = cleaned.slice(3, 6);
		const lineNumber = cleaned.slice(6);
		return `(${areaCode}) ${centralOffice}-${lineNumber}`;
	}

	export function formatAddress(line1, line2, city, state, zip, country) {
		let addressParts = [line1];
		if (line2) {
			addressParts.push(line2);
		}
		if (zip?.length > 5) {
			zip = formatZipCode(zip);
		}
		addressParts.push(`${city}, ${state} ${zip}`);
		addressParts.push(country);
		return addressParts.join(`<br>`);
	}

	export function formatZipCode(value) {
		if (!value) return "";
		const cleaned = value.replace(/\D/g, "").slice(0, 9);
		return cleaned.length > 5
			? `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`
			: cleaned;
	}

	export function debounce(func, delay) {
		let timer;
		return function (...args) {
			clearTimeout(timer);
			timer = setTimeout(() => {
				func.apply(this, args);
			}, delay);
		};
	}

	export function debouncePromise(func, wait) {
		let timeout;
		// Store all pending promises' resolve/reject callbacks
		let pending = [];

		return function (...args) {
			// Clear the previous timeout with each new call
			clearTimeout(timeout);

			// Create a new promise for the current call
			return new Promise((resolve, reject) => {
				// Add the current promise's callbacks to the pending array
				pending.push({ resolve, reject });

				// Set a new timeout
				timeout = setTimeout(() => {
					// When the delay passes, capture the current pending list
					const currentPending = pending.slice();
					// Clear the main pending list
					pending = [];

					// Execute the original function (which is expected to return a Promise)
					func.apply(this, args)
						.then((result) => {
							// Resolve all promises that were pending when the function finally ran
							for (const p of currentPending) {
								p.resolve(result);
							}
						})
						.catch((error) => {
							// Reject all promises if the function fails
							for (const p of currentPending) {
								p.reject(error);
							}
						});
				}, wait);
			});
		};
	}

	export function getDateFormatter(format = "MM/dd/yyyy") {
		if (!format || format.toLowerCase() === "mm/dd/yyyy") {
			return new Intl.DateTimeFormat("en-US", {
				month: "2-digit",
				day: "2-digit",
				year: "numeric",
			});
		}
	}

	export function isValidDate(dateString) {
		// Regular expression to check for the mm/dd/yyyy format
		const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[01])\/\d{4}$/;

		//console.log("isvaliddate:", dateString);
		if (!regex.test(dateString)) {
			return false; // Does not match the mm/dd/yyyy format
		}

		//console.log("isvaliddate:", "regex OK")
		// Create a Date object from the string
		const dateObject = new Date(dateString);
		const isDateObject = dateObject instanceof Date && !isNaN(dateObject);
		if (!isDateObject) {
			return false; // Could not be cast to Date
		}
		//console.log("isvaliddate:", dateObject)

		// Check if the Date object is valid (not "Invalid Date")
		// and if the month/day/year match the original input to handle rollovers
		const [month, day, year] = dateString.split("/").map(Number);
		//console.log("isvaliddate:", month, day, year)
		//console.log("isvaliddate:",dateObject.getMonth() + 1, dateObject.getDate(), dateObject.getFullYear())
		return (
			!isNaN(dateObject) &&
			dateObject.getMonth() + 1 === month && // Month is 0-indexed in Date object
			dateObject.getDate() === day &&
			dateObject.getFullYear() === year
		);
	}

	function closeWindow() {
		var domain = "pehp";
		document.body.innerHTML = "";
		window.open("", "_self", "");
		window.close();
		setTimeout(function() { window.location = "https://www." + domain + ".org" }, 3000);
	}
</script>
